import { Link } from "react-router-dom";

export function SelectItems(): JSX.Element {
  return (
    <ul>
      <li>
        <Link to="/anasys">拡散式硫化水素測定器 GHS-8ATソフトウェア</Link>
      </li>
      <li>
        <Link to="/cmcd-200">
          一酸化炭素・二酸化炭素測定器 CMCD-200ソフトウェア
        </Link>
      </li>
      <li>
        <Link to="/gas-log-reader">
          ロギングデータ読み取りソフトGasLogReader
        </Link>
      </li>
    </ul>
  );
}
